module.exports = __webpack_public_path__ + "img/wechat-qr.8e4f73c3.png";